const DEFAULT_LANDING = "/";

/**
 * `?volver=` (LoginPage; contracts/oauth.md §4) solo puede ser una ruta del propio panel: empieza por una
 * única `/` (nunca `//`, protocolo-relativo) y, resuelta contra el origen actual, sigue en ese origen — así
 * `https://malo.example`/`//malo.example` nunca sacan a la persona del panel. Por defecto vuelve a `/`, que
 * la manda a su cliente.
 */
export function sanitizeVolverPath(raw: string | null): string {
  if (!raw || !raw.startsWith("/") || raw.startsWith("//") || raw.includes("\\")) return DEFAULT_LANDING;
  try {
    const resolved = new URL(raw, window.location.origin);
    if (resolved.origin !== window.location.origin) return DEFAULT_LANDING;
    return `${resolved.pathname}${resolved.search}${resolved.hash}`;
  } catch {
    return DEFAULT_LANDING;
  }
}
